import { VariableSizeList as List } from 'react-window';
import styled from 'styled-components';

import { scrollbarStyles } from '@web/components/ScrollableContainer/ScrollableContainer';

import { PADDING } from './mentionSuggestions.consts';
import { Position } from './mentionSuggestions.types';

export const Wrapper = styled.div<Position>`
  background-color: ${({ theme }): string => theme.colors.white};
  box-shadow: ${({ theme }) => theme.boxShadows.bottomLight};
  display: flex;
  left: ${({ left }): string => `${left}px`};
  position: absolute;
  top: ${({ top }): string => `${top}px`};
  z-index: 1060; // angular modal has z-index 1050
`;

// margin right is smaller to add extra space for scrollbar
const styleListMargin = `${PADDING}px 0 ${PADDING}px ${PADDING}px`;

export const StyledList = styled(List)`
  margin: ${styleListMargin};

  ${scrollbarStyles}
`;
